import {Injectable} from '@angular/core';
import {BullhornEntityType} from '../types/bullhorn/bullhorn-entity-type';

@Injectable({providedIn: 'root'})
export class BullhornIconService {
  getIcon(type: BullhornEntityType): string {
    switch (type) {
      case BullhornEntityType.CANDIDATE:
        return 'bhi-candidate';
      case BullhornEntityType.CLIENT_CONTACT:
        return 'bhi-person';
      case BullhornEntityType.CLIENT_CORPORATION:
        return 'bhi-company';
      case BullhornEntityType.JOB_ORDER:
        return 'bhi-job';
      case BullhornEntityType.JOB_SUBMISSION:
        return 'bhi-star submission';
      case BullhornEntityType.PLACEMENT:
        return 'bhi-star';
      case BullhornEntityType.LEAD:
        return 'bhi-lead';
      case BullhornEntityType.OPPORTUNITY:
        return 'bhi-opportunity';
      case BullhornEntityType.APPOINTMENT:
        return 'bhi-appointment';
      case BullhornEntityType.TASK:
        return 'bhi-check-o';
      case BullhornEntityType.NOTE:
        return 'bhi-add-note';
      default:
        return '';
    }
  }
}
